import { deserialize, fetchWrapper } from '../fetch';
import type { Activity } from './interface';

export const fetchActivities = async (
  dossierId: string
): Promise<Activity[]> => {
  const url = new URL(`/app/v1/activities/dossier/${dossierId}`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const fetchActivity = async (data: {
  dossierId: string;
  activityId: string;
}): Promise<Activity> => {
  const url = new URL(`/app/v1/activities/${data.activityId}`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
